import ContentLoader from 'react-content-loader';

const CommunicationSkeleton = () => {
	return (
		<ContentLoader viewBox="0 0 400 100">
			<rect x="0" y="5" rx="3" ry="3" width="18" height="18" />
			<rect x="30" y="5" rx="3" ry="3" width="370" height="15" />

			<rect x="0" y="35" rx="3" ry="3" width="18" height="18" />
			<rect x="30" y="35" rx="3" ry="3" width="370" height="15" />

			<rect x="0" y="65" rx="3" ry="3" width="18" height="18" />
			<rect x="30" y="65" rx="3" ry="3" width="370" height="15" />
		</ContentLoader>
	);
};

export default CommunicationSkeleton;
